const DEFAULT_MEASUREMENT_ID = 'G-DBHXC5FHWY'

export interface Props {
	nonce: string
	enabled: boolean
	measurementId?: string
}

export function GoogleAnalytics({
	nonce,
	enabled,
	measurementId = DEFAULT_MEASUREMENT_ID,
}: Props) {
	if (!enabled) return null
	return (
		<>
			<script
				async
				src={`https://www.googletagmanager.com/gtag/js?id=${measurementId}`}
				nonce={nonce}
			/>
			<script
				nonce={nonce}
				dangerouslySetInnerHTML={{
					__html: `
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
// Disable automatic page_view to avoid duplicates in SPA
gtag('config', '${measurementId}', { anonymize_ip: true, send_page_view: false });
`,
				}}
			/>
		</>
	)
}
